module.exports = __webpack_public_path__ + "img/opeico.ffe0001a.png";